import axios, { AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const isProduction = process.env.NODE_ENV === 'production';

export const setCookie = (name: string, value: string | number, minutes: number) => {
    const expiryDate = new Date(Date.now() + minutes * 60 * 1000);
    cookies.set(name, value, { path: '/', expires: expiryDate, secure: isProduction });
};

export const getCookie = (name: string) => cookies.get(name);
export const removeCookie = (name: string) => cookies.remove(name, { path: '/' });

// const setToken = (name: string, token: string, expiresInMinutes: number) => {
//     setCookie(name, token, expiresInMinutes);
//     setCookie(`${name}_expiry`, Math.floor(Date.now() / 1000) + expiresInMinutes * 60, expiresInMinutes);
// };

// export const clearTokens = () => {
//     ['access_token', 'refresh_token', 'username'].forEach(removeCookie);
// };


const makeRequest = async (type: string, endpoint: string, data?: any, config?: AxiosRequestConfig) => {
    const url = `${process.env.NEXT_PUBLIC_API_URL}${endpoint}`;
    switch (type.toUpperCase()) {
        case "GET":
            return (await axios.get(url, config)).data;
        case "POST":
            return (await axios.post(url, data, config)).data;
        case "PUT":
        case "UPDATE":
            return (await axios.put(url, data, config)).data;
        case "DELETE":
            return (await axios.delete(url, config)).data;
        default:
            throw new Error(`Unsupported request type: ${type}`);
    }
};


export const sendRequest = async (type: string, endpoint: string, data?: any, silenceError: boolean = false): Promise<any> => {
    try {
        return await makeRequest(type, endpoint, data);
    }catch (error:any) {
        if (typeof window !== "undefined") {
            if (!silenceError) {
                if (error.response) {
                    const statusCode = error.response.status;
                    const errorMessage = error.response.data.message || "Тодорхойгүй алдаа. Дараа дахин оролдоно уу.";
                    if (statusCode === 400) {
                        toast.error(errorMessage);
                    } else if (statusCode === 500) {
                        toast.error("Серверт холбогдоход алдаа гарлаа. Та дахин оролдоно уу."); // Server error message
                    } else {
                        toast.error("Тодорхойгүй алдаа. Дараа дахин оролдоно уу.");
                    }
                } else {
                    toast.error("Тодорхойгүй алдаа. Дараа дахин оролдоно уу.");
                }
            }
        }
        return null;
    }
};


export const getImageUrl = (path:string) => {
    return `https://api.narscamp.mn${path}`;
}